import { Injectable } from "@angular/core";
import { Router } from "@angular/router";
import { AppConfigService } from "../app-config.service";

declare var gtag: any;

export interface GtagEvent {
  event_category?: string;
  event_label?: string;
  value?: any;
  [key: string]: any;
}

export interface GtagPageView {
  page_title?: string;
  page_path?: string;
  page_location?: string;
  site?: string;
  [key: string]: any;
}

@Injectable()
export class GtagService {
  trackingId: string = '';

  constructor(private router: Router, private appConfig: AppConfigService) {
    this.trackingId = appConfig.getValue('trackingId');
  }

  event(action: string, params: GtagEvent = {}) {
    try {
      // gtag('event', this.trackingId, action, params);
      params = {site: window.location.origin, ...params};
      gtag('event', action, params);
    } catch (err) {
      console.error('Google Analytics event error', err);
    }
  }

  pageview(params?: GtagPageView) {
    try {
      const defaults = {
        page_path: this.router.url,
        page_title: 'Anytrack App',
        page_location: window.location.href,
        site: window.location.origin
      };

      params = { ...defaults, ...params };

      // gtag('config', this.trackingId, params);
      gtag('config', params);
    } catch (err) {
      console.error('Google Analytics pageview error', err);
    }
  }

  pageview2(pageTitle: string, params?: any) {
    try {
      const defaults = {
        page_path: this.router.url,
        page_title: pageTitle,
        page_location: window.location.href,
        site: window.location.origin
      };

      params = { ...defaults, ...params };

      // gtag('config', this.trackingId, params);
      gtag('event', 'page_view', params);
    } catch (err) {
      console.error('Google Analytics pageview2 error', err);
    }
  }

  config(params: any) {
    try {
      gtag('config', this.trackingId, params = {});
    } catch (err) {
      console.error('Google Analytics config error', err);
    }
  }

  set(params: any) {
    try {
      gtag('set', this.trackingId, (params = {}));
    } catch (err) {
      console.error('Google Analytics set error', err);
    }
  }

  get(param: string): Promise<any> {
    const res = new Promise((resolve, reject) => {
      try {
        gtag('get', this.trackingId, param, (data: any) => {
          resolve(data);
        });
      } catch (err) {
        console.error('Google Analytics get param error', err);
        reject({ "error": err });
      }

    });

    return res;
  }

}